var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simplecard"},[_c('div',{staticClass:"simplecard-content has-text-centered"},[_c('h6',{staticClass:"simplecard-title"},[_vm._t("title")],2),_vm._t("content")],2),_c('div',{staticClass:"simplecard-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }